import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {FooterHelp, Page, Link, Banner} from '@shopify/polaris'
import moment from 'moment'

import ItemListComponent from '../../components/item-list'

const Mappers = (props) => {
  const app = useSelector(state => state.app)
  const [shouldShowBanner, setShouldShowBanner] = useState(false)
  useEffect(() => {
    const appVer3ReleasedDate = moment('2020-12-08')
    const appVer3BannerEnd = moment('2021-01-08')
    const shopCreatedAtTime = moment(app.createdAt)
    setShouldShowBanner(shopCreatedAtTime < appVer3ReleasedDate && moment() < appVer3BannerEnd)
  }, [])

  return (
    <div>
      {shouldShowBanner && <Page fullWidth>
        <Banner title="Image Mapper - Shoppable Image app has been updated to version 2.0.0">
          <p>
            This is a major app upgrade that brings a lots of new features and improvements. <a href="/docs#/changelog" target="_blank">Learn more.</a><br/>
            If you have any difficulties in using this new app version, please contact me via <a href="mailto:lucdkny@gmail.com" target="_blank">lucdkny@gmail.com</a>
          </p>
        </Banner>
      </Page>}

      <Page
        fullWidth
        title='Mappers'
        primaryAction={{
          content: 'Add Mapper',
          url: '/mappers/new'
        }}
      >
        <ItemListComponent
          resourceName={{
            singular: 'mapper',
            plural: 'mappers'
          }}
          endpoint={`/api/v2/admin/mappers`}
        />
        <FooterHelp>
          Learn more about<Link url="/docs#/create-your-first-mapper" external> creating your first mapper</Link>
        </FooterHelp>
      </Page>
    </div>
  )
}

export default Mappers
